import React, { useState } from 'react';
import { Badge, Button, Card, Col, Modal, Row, Form } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import useProfileStore from '../../store/patient/profileStore';
import useManageLabRequests from '../../hooks/patientDashboard/usemanageLabrequests';

const LabCartModal = ({ show, setShow, cartItems, setCartItems }) => {
    const { profile } = useProfileStore();
    const { handleSubmitRequest } = useManageLabRequests();

    const [submitting, setSubmitting] = useState(false);
    const [step, setStep] = useState(1);

    const [selectedPayment, setSelectedPayment] = useState("");
    const [note, setNote] = useState("");
    const [deliveryMethod, setDeliveryMethod] = useState("");
    const [deliveryAddress, setDeliveryAddress] = useState("");

    const handleClose = () => setShow(false);

    const removeItem = (id) => {
        setCartItems((prev) => prev.filter((item) => item?.id !== id));
    };

    const navigate = useNavigate();

    const totalPrice = cartItems?.reduce((sum, item) => sum + ((item?.serviceCost?.tariff || 0) * (item?.quantity || 1)), 0);
    const tax = totalPrice * (7.5 / 107.5);

    const handleSubmit = async () => {
        if (!selectedPayment) {
            toast.error("Please select a payment method");
            return;
        }

        setSubmitting(true);
        try {
            const request_type = "labs";
            let requestNote = {
                request_note: note,
                delivery_method: deliveryMethod,
                delivery_address: deliveryMethod === 'home' ? deliveryAddress : ''
            };

            const response = await handleSubmitRequest(profile?.id, request_type, cartItems, requestNote);

            if (response.status === 201 || response.status === 200) {
                handleClose();
                setCartItems([]);
                toast.success('Operation Successfully!');
                setStep(1);
                setNote("");
                setDeliveryMethod("");
                setDeliveryAddress("");
                setSelectedPayment("");
                navigate("/lab-request/history")
                
            } else {
                console.error("An unknown error occurred");
            }
        } catch (error) {
            console.log(error);
        }
        setSubmitting(false);
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    {step === 1 && "Selected Lab Test"}
                    {step === 2 && "Delivery Method"}
                    {step === 3 && "Cart Summary"}
                    {step === 4 && "Select Payment Method"}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {step === 1 && (
                    <Row>
                        {cartItems?.length === 0 ? (
                            <h4>No Lab in cart</h4>
                        ) : (
                            cartItems.map((item) => (
                                <Col sm="6" className='mb-2' key={item.id}>
                                    <Card className="card-event">
                                        <Card.Body className='d-flex align-items-center gap-2 p-2'>
                                            <div className="avatar">
                                                <span className="avatar-initial fs-20 bg-primary">
                                                    <i className="ri-shopping-cart-line"></i>
                                                </span>
                                            </div>
                                            <div className='d-flex flex-column align-items-center'>
                                                <h6>
                                                    <Link to="" className='fs-sm'>{item.name}</Link>
                                                </h6>
                                                <p className="text-secondary fs-sm m-0">{item?.category?.name}</p>
                                            </div>
                                        </Card.Body>
                                        <div className="divider divider-start fw-medium m-0"></div>
                                        <Card.Footer className='d-flex justify-content-between p-2'>
                                            <Badge onClick={() => removeItem(item.id)} style={{ cursor: "pointer" }} bg="danger">
                                                Remove
                                            </Badge>
                                        </Card.Footer>
                                    </Card>
                                </Col>
                            ))
                        )}
                        <div style={{ padding: '10px' }}>
                            <Form.Label>Add Note</Form.Label>
                            <Form.Control
                                as="textarea"
                                value={note}
                                onChange={(e) => setNote(e.target.value)}
                                rows="3"
                                placeholder="Enter Reason here..."
                            />
                        </div>
                    </Row>
                )}

                {step === 3 && (
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Select Delivery Method</Form.Label>
                            <Form.Select
                                value={deliveryMethod}
                                onChange={(e) => setDeliveryMethod(e.target.value)}
                            >
                                <option value="">-- Select --</option>
                                <option value="home">Home Delivery</option>
                                <option value="facility">Collect at Facility</option>
                            </Form.Select>
                        </Form.Group>

                        {deliveryMethod === "home" && (
                            <Form.Group className="mb-3">
                                <Form.Label>Enter Delivery Address</Form.Label>
                                <Form.Control
                                    type="text"
                                    Cols={2}
                                    placeholder="Enter your home address"
                                    value={deliveryAddress}
                                    onChange={(e) => setDeliveryAddress(e.target.value)}
                                />
                            </Form.Group>
                        )}
                    </Form>
                )}

                {step === 2 && (
                    <div>
                        <h5>Summary of your order:</h5>
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Lab Name</th>
                                    <th>Price (₦)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {cartItems.map((item, index) => (
                                    <tr key={item.id}>
                                        <td>{index + 1}</td>
                                        <td>{item.name}</td>
                                        <td>{(item?.serviceCost?.tariff * item?.quantity).toLocaleString()}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <div className='w-100 d-flex justify-content-end'>
                            <div>
                                <h6>Tax (7.5% incl.): ₦{tax.toFixed(2)}</h6>
                                <h5>Total: ₦{totalPrice.toLocaleString()}</h5>
                            </div>
                        </div>
                    </div>
                )}

                {step === 4 && (
                    <Form>
                        <h5>Select a Payment Method:</h5>
                        <Form.Check
                            type="radio"
                            label="Pay in the Facility (Hospital)"
                            name="paymentMethod"
                            value="Monnify"
                            checked={selectedPayment === "Monnify"}
                            onChange={(e) => setSelectedPayment(e.target.value)}
                        />
                        {/* Future methods */}
                        <Form.Check
                            type="radio"
                            label="Paystack"
                            name="paymentMethod"
                            value="Paystack"
                            disabled={true}
                            checked={selectedPayment === "Paystack"}
                            onChange={(e) => setSelectedPayment(e.target.value)}
                        />
                    </Form>
                )}
            </Modal.Body>

            <Modal.Footer>
                {step > 1 && (
                    <Button variant="secondary" onClick={() => setStep(step - 1)}>
                        Back
                    </Button>
                )}
                {step === 1 && (
                    <Button
                        variant="primary"
                        onClick={() => cartItems.length === 0 ? null : setStep(2)}
                        disabled={cartItems.length === 0}
                    >
                        Continue
                    </Button>
                )}
                {step === 3 && (
                    <Button
                        variant="primary"
                        onClick={() => {
                            if (!deliveryMethod) {
                                toast.error("Please select delivery method");
                                return;
                            }
                            if (deliveryMethod === 'home' && !deliveryAddress.trim()) {
                                toast.error("Please enter delivery address");
                                return;
                            }
                            setStep(4);
                        }}
                    >
                         Proceed to Payment
                    </Button>
                )}
                {step === 2 && (
                    <Button variant="primary" onClick={() => setStep(3)}>
                       Continue
                    </Button>
                )}
                {step === 4 && (
                    <Button variant="primary" disabled={submitting} onClick={handleSubmit}>
                        {submitting ? "Processing..." : "Checkout"}
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    );
};

export default LabCartModal;
